import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class PanelNavigationService {

    // subject to zmian listy lite
    private visiblityChangeSubject: Subject<any> = new Subject<any>();

    // obsluga parametrow przychodzacych z url
    public resolve(change: any) {
        // podjecie decyzji co gdzie oublikowac
        this.visiblityChangeSubject.next({ show: false });


        // dalej
        const msg = this.prepareMessage(change);
        this.visiblityChangeSubject.next(msg);
    }

    public prepareMessage(change: any) {
        const url = change.url;
        const query = change.query;
        const id = query.params.id;
        const key = url.params.subsite + '-' + query.params.mode;
        const result = { subsites: [key], show: true, id: id };
        return result;
    }

    // pobranie subjectu
    getVisibilitySubject(): Subject<any> {
        return this.visiblityChangeSubject;
    }
}
